import React from 'react';

const TABS = [
  { id: 'domains', label: 'Domains' },
  { id: 'contacts', label: 'Contacts' },
  { id: 'emails', label: 'Emails' },
];

function PipelineTabs({
  active,
  onSelect,
  domainCount = 0,
  contactCount = 0,
  emailCount = 0,
  domainsRunning = false,
  contactsRunning = false,
}) {
  const counts = {
    domains: domainCount,
    contacts: contactCount,
    emails: emailCount,
  };
  const running = {
    domains: domainsRunning,
    contacts: contactsRunning,
    emails: false,
  };

  return (
    <header className="flex-shrink-0 border-b border-paper-line bg-white">
      <div className="px-8 pt-5 pb-2">
        <div className="text-[18px] font-semibold tracking-tight text-ink leading-tight">
          Outreach Builder
        </div>
        <nav className="flex items-center gap-0.5 mt-3 -ml-2" aria-label="Views">
          {TABS.map((tab) => {
            const selected = active === tab.id;
            const isRunning = running[tab.id];
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => onSelect(tab.id)}
                className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-[4px] text-[14px] font-medium transition-colors duration-150 ${
                  selected
                    ? 'bg-wash text-ink'
                    : 'text-ink-muted hover:bg-wash hover:text-ink'
                }`}
              >
                {tab.label}
                <span className="text-[12px] font-normal text-ink-faint tabular-nums">
                  {counts[tab.id] || 0}
                </span>
                {isRunning && (
                  <span className="w-1.5 h-1.5 rounded-full bg-ok animate-pulse" title="Running" />
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

export default PipelineTabs;
